<modal (closeOut)="close()" (close)="close()" width="425">
  <modal-header>
    <span>{{ strings.insertLink }}</span>
  </modal-header>

  <modal-body>
    <form [formGroup]="form">
      <div class="form-group">
        <label for="url">{{ strings.url }}</label>
        <input id="url" formControlName="url" kendoTextBox type="text" placeholder="{{ strings.linkPlaceholder }}" />
        @if (getError('url'); as error) {
          <div class="error-message">{{ error }}</div>
        }
      </div>

      <div class="form-group">
        <label for="title">{{ strings.title }}</label>
        <input id="title" formControlName="title" kendoTextBox type="text" placeholder="{{ strings.title }}" />
        @if (getError('title'); as error) {
          <div class="error-message">{{ error }}</div>
        }
      </div>

      <kendo-checkbox formControlName="openInNewWindow" focusableId="openInNewWindow" />
      <label class="k-checkbox-label" for="openInNewWindow">{{ strings.openLinkInNewWindow }}</label>
    </form>
  </modal-body>

  <modal-actions>
    <button kendoButton fillMode="solid" themeColor="tertiary" (click)="close()">{{ miscStrings.cancel }}</button>
    <button kendoButton fillMode="solid" themeColor="primary" [disabled]="!isValid" (click)="insertLink()">
      {{ strings.insert }}
    </button>
  </modal-actions>
</modal>
